module.exports = __webpack_public_path__ + "img/159.088431f0.png";